$(document).ready(function() {
    console.log("ready");
  $("#judgeme_product_reviews").parent().hide();
  $(".show_details").addClass("active");

  $(".jdgm-prev-badge").on("click", function(){
    $(".show_reviews").trigger("click");
  });

  $(".show_reviews").on("click", function(){
    $(this).addClass("active");
    $(".show_details").removeClass("active");
    $(".product__description").hide();
    $("#judgeme_product_reviews").parent().show();
  });

  $(".show_details").on("click", function(){
    $(this).addClass("active");
    $(".show_reviews").removeClass("active");
    $(".product__description").show();
    $("#judgeme_product_reviews").parent().hide();
  });
});